<template lang='pug'>
div(:class='$style[`audio-player`]')
  div(v-if='preloading' :class='$style[`audio-player-wrap`]')
    div(:class='$style[`audio-player-wrap-loading`]')
      IconLoading(:size='42' :color='`#b1b1b1`')
      span 播放器準備中..

  div(v-else :class='$style[`audio-player-wrap`]')
    div(:class='$style[`player-controls`]')
      div(:class='$style[`player-controls-topper`]')
        div#seek(:class='$style[`seek`]')
          div(:class='$style[`player-timeline`]')
            div(:style='progressStyle' :class='$style[`player-progress`]')
            div(@click='seek' title='Seek' :class='$style[`player-seeker`]')

          div(:class='$style[`player-time`]')
            div(:class='$style[`player-time-current`]') {{ this.currentSeconds | convertTimeHHMMSS }}
            div(:class='$style[`player-time-total`]') {{ this.durationSeconds | convertTimeHHMMSS }}

      div(:class='$style[`player-controls-bottom`]')
        //- div(id='stop')
        //-   button(@click.prevent='stop' title='Stop')
        //-     svg(viewBox='0 0 20 20')
        //-       path(d='M16,4.995v9.808C16,15.464,15.464,16,14.804,16H4.997C4.446,16,4,15.554,4,15.003V5.196C4,4.536,4.536,4,5.196,4h9.808C15.554,4,16,4.446,16,4.995z')

        //- div(id='download' v-show='!showVolume')
        //-   button(@click.prevent='download' title='Download')
        //-     svg(viewBox='0 0 20 20')
        //-       path d='M15,7h-3V1H8v6H5l5,5L15,7z M19.338,13.532c-0.21-0.224-1.611-1.723-2.011-2.114C17.062,11.159,16.683,11,16.285,11h-1.757l3.064,2.994h-3.544c-0.102,0-0.194,0.052-0.24,0.133L12.992,16H7.008l-0.816-1.873c-0.046-0.081-0.139-0.133-0.24-0.133H2.408L5.471,11H3.715c-0.397,0-0.776,0.159-1.042,0.418c-0.4,0.392-1.801,1.891-2.011,2.114c-0.489,0.521-0.758,0.936-0.63,1.449l0.561,3.074c0.128,0.514,0.691,0.936,1.252,0.936h16.312c0.561,0,1.124-0.422,1.252-0.936l0.561-3.074C20.096,14.468,19.828,14.053,19.338,13.532z')

        div#play(:class='$style[`play`]')
          button(
            @click.prevent='playing = !playing'
            :title='(playing) ? `暫停` : `播放`')
            svg(viewBox='0 0 20 20' style='width: 2.6rem')
              path(v-if='!playing' d='M15,10.001c0,0.299-0.305,0.514-0.305,0.514l-8.561,5.303C5.51,16.227,5,15.924,5,15.149V4.852c0-0.777,0.51-1.078,1.135-0.67l8.561,5.305C14.695,9.487,15,9.702,15,10.001z')
              path(v-else d='M15,3h-2c-0.553,0-1,0.048-1,0.6v12.8c0,0.552,0.447,0.6,1,0.6h2c0.553,0,1-0.048,1-0.6V3.6C16,3.048,15.553,3,15,3z M7,3H5C4.447,3,4,3.048,4,3.6v12.8C4,16.952,4.447,17,5,17h2c0.553,0,1-0.048,1-0.6V3.6C8,3.048,7.553,3,7,3z')

        div#loop(:class='$style[`loop`]')
          button(
            @click.prevent='looping = !looping'
            title='開啟重複播放')
            svg(v-if='looping' viewBox='0 0 20 20' style='width: 2.6rem;')
              path(d='M20,7v7c0,1.103-0.896,2-2,2H2c-1.104,0-2-0.897-2-2V7c0-1.104,0.896-2,2-2h7V3l4,3.5L9,10V8H3v5h14V8h-3V5h4C19.104,5,20,5.896,20,7z')
            svg(v-else viewBox='0 0 20 20' style='width: 2.6rem; fill: #e0e0e0;')
              path(d='M20,7v7c0,1.103-0.896,2-2,2H2c-1.104,0-2-0.897-2-2V7c0-1.104,0.896-2,2-2h7V3l4,3.5L9,10V8H3v5h14V8h-3V5h4C19.104,5,20,5.896,20,7z')

        //- div(id='mute')
        //-   button(@click.prevent='mute' title='Mute')
        //-     svg(viewBox='0 0 20 20')
        //-       path(v-if='!muted' d='M5.312,4.566C4.19,5.685-0.715,12.681,3.523,16.918c4.236,4.238,11.23-0.668,12.354-1.789c1.121-1.119-0.335-4.395-3.252-7.312C9.706,4.898,6.434,3.441,5.312,4.566z M14.576,14.156c-0.332,0.328-2.895-0.457-5.364-2.928C6.745,8.759,5.956,6.195,6.288,5.865c0.328-0.332,2.894,0.457,5.36,2.926C14.119,11.258,14.906,13.824,14.576,14.156zM15.434,5.982l1.904-1.906c0.391-0.391,0.391-1.023,0-1.414c-0.39-0.391-1.023-0.391-1.414,0L14.02,4.568c-0.391,0.391-0.391,1.024,0,1.414C14.41,6.372,15.043,6.372,15.434,5.982z M11.124,3.8c0.483,0.268,1.091,0.095,1.36-0.388l1.087-1.926c0.268-0.483,0.095-1.091-0.388-1.36c-0.482-0.269-1.091-0.095-1.36,0.388L10.736,2.44C10.468,2.924,10.642,3.533,11.124,3.8z M19.872,6.816c-0.267-0.483-0.877-0.657-1.36-0.388l-1.94,1.061c-0.483,0.268-0.657,0.878-0.388,1.36c0.268,0.483,0.877,0.657,1.36,0.388l1.94-1.061C19.967,7.907,20.141,7.299,19.872,6.816z')
        //-       path(v-else d='M14.201,9.194c1.389,1.883,1.818,3.517,1.559,3.777c-0.26,0.258-1.893-0.17-3.778-1.559l-5.526,5.527c4.186,1.838,9.627-2.018,10.605-2.996c0.925-0.922,0.097-3.309-1.856-5.754L14.201,9.194z M8.667,7.941c-1.099-1.658-1.431-3.023-1.194-3.26c0.233-0.234,1.6,0.096,3.257,1.197l1.023-1.025C9.489,3.179,7.358,2.519,6.496,3.384C5.568,4.31,2.048,9.261,3.265,13.341L8.667,7.941z M18.521,1.478c-0.39-0.391-1.023-0.391-1.414,0L1.478,17.108c-0.391,0.391-0.391,1.024,0,1.414c0.391,0.391,1.023,0.391,1.414,0l15.629-15.63C18.912,2.501,18.912,1.868,18.521,1.478z')

        //- div(id='volume')
        //-   button(
        //-     @click.prevent=''
        //-     @mouseenter='showVolume = true'
        //-     @mouseleave='showVolume = false'
        //-     :title='volumeTitle')
        //-     svg(viewBox='0 0 20 20')
        //-       path d='M19,13.805C19,14.462,18.462,15,17.805,15H1.533c-0.88,0-0.982-0.371-0.229-0.822l16.323-9.055C18.382,4.67,19,5.019,19,5.9V13.805z')

        //-     input(v-model.lazy.number='volume' v-show='showVolume' class='player-volume' type='range' min='0' max='100')

  audio(
    ref='audio'
    preload='auto'
    :loop='looping'
    @timeupdate='update'
    @loadeddata='onLoadData'
    @pause='playing = false'
    @play='playing = true'
    @ended='endToNext'
    style='display: none;')

    source(:src='avatarSrcLink(file)' type="audio/mpeg")
    //- @oncanplay='onCanPlay'
    //- @canplaythrough='onLoadData'
    //- preload='auto'
    //- controlsList="nodownload noplaybackrate"
    //- crossorigin='anonymous'
    //- @oncanplay='onLoadData'
    //- source(:src='avatarSrcLink(file)' type="audio/wav")

</template>

<script>
import { mapGetters } from 'vuex';
import IconLoading from '../../icon/Loading';

export default {
  props: {
    autoPlay: {
      type: Boolean,
      default: true
    },
    file: {
      type: String,
      default: null
    },
    loop: {
      type: Boolean,
      default: false
    },
    nextUnit: {
      type: Number,
      default: null
    }
  },

  components: {
    IconLoading,
  },

  filters: {
    convertTimeHHMMSS(val) {
      // let hhmmss = new Date(val * 1000).toISOString().substr(11, 8);
      let hhmmss = new Date(val * 1000).toISOString().substring(14, 19);
      // console.log('hhmmss', hhmmss.substring(14, 19));
      return hhmmss;
    }
  },

  mounted() {
    this.preloading = false;
    // if ('ontouchstart' in document.documentElement) {
    //   document.addEventListener('touchstart', this.onTouchStartPlay, false);
    // }
  },

  beforeDestroy() {
    if (this.$refs.audio) {
      this.$refs.audio.src = '';
    }
  },

  destroyed() {
    this.$emit('resetAudio');
  },

  data() {
    return {
      preloading: true,
      currentSeconds: 0,
      durationSeconds: 0,
      loaded: false,
      looping: this.loop,
      playing: false,

      // previousVolume: 35,
      // showVolume: false,
      // volume: 100
    };
  },

  methods: {
    // download() {
    // 	this.stop();
    // 	window.open(this.file, 'download');
    // },

    // onTouchStartPlay() {
    //   this.$refs.audio.play();
    //   this.playing = true;
    // },

    // onCanPlay() {
    //   this.preloading = false;
    // },

    onLoadData() { 
      if (this.$refs.audio.readyState >= 3) {
        this.loaded = true;
        this.durationSeconds = parseInt(this.$refs.audio.duration);
        console.log('Check Audio LOAD 2', this.$refs.audio.readyState);
        return this.playing = this.autoPlay;
      }
      throw new Error('Failed to load sound file.');
    },

    endToNext() {
      // console.log('detect ended')
      if (!this.looping && this.nextUnit) {
        this.$emit('switchNext', this.nextUnit);
      }
    },

		// mute() {
    //   if (this.muted) {
    //     return this.volume = this.previousVolume;
    //   }
    //   this.previousVolume = this.volume;
    //   this.volume = 0;
    // },

    seek(e) {
      if (!this.loaded) return;
      const bounds = e.target.getBoundingClientRect();
      const seekPos = (e.clientX - bounds.left) / bounds.width;

      if (this.$refs.audio.seekable.length > 0) {
        // this.$refs.audio.currentTime = 60;
        this.$refs.audio.currentTime = parseInt(this.$refs.audio.duration * seekPos);;
        console.log('seek', this.$refs.audio);
      }
    },

    // stop() {
    //   if (!this.popCourseStatus.active || !this.$refs.audio) return;
    //   this.playing = false;
    //   this.$refs.audio.currentTime = 0;
    // },

    update(e) {
      if (!this.popCourseStatus.active || !this.$refs.audio) return;
      this.currentSeconds = parseInt(this.$refs.audio.currentTime);
    }
  },

  computed: {
    ...mapGetters({
      popCourseStatus: 'global/exportPopCourseStatus',
    }),

    // muted() {
    //   return this.volume / 100 === 0;
    // },

    percentComplete() {
      return parseInt(this.currentSeconds / this.durationSeconds * 100);
    },

    progressStyle() {
      return { width: `${this.percentComplete}%` };
    },

    // volumeTitle() {
    //   return `Volume (${this.volume}%)`;
    // },
  },

  watch: {
    playing(value) {
      if (value) {
        return this.$refs.audio.play();
      } else {
        this.$refs.audio.pause();
        // if (!this.looping && this.nextUnit) {
        //   this.$emit('switchNext', this.nextUnit);
        // }
      }
    },
    // volume(value) {
    //   this.$refs.audio.volume = this.volume / 100;
    // },
  },
}
</script>

<style module lang='scss'>
  @import '../../../sass/component/page/common/audioPlayer.scss';
</style>